export default ['.ttf', '.otf', '.eot', '.woff', '.woff2'];